import AIInteractionTable from "../../Components/AIInteractionTable";
import PageContainer from "../PageContainer"

const AIInteractionConfiguration = () => {
  return (
    <> 
    <PageContainer>
        {/* <h1>AI Interaction Configuration</h1> */}
        <AIInteractionTable/>
    </PageContainer>
    </>
  );
}
export default AIInteractionConfiguration;